import { Link } from "react-router-dom";

export function Logo({ inverse = false, size = "md" }) {
  const primary = inverse ? "text-white" : "text-slate-900";
  const accent = inverse ? "text-orange-400" : "text-orange-600";
  const border = inverse ? "border-white/20" : "border-slate-900/10";
  const box = inverse ? "bg-white/5" : "bg-slate-900";
  const boxText = inverse ? "text-white" : "text-white";

  const dim = size === "sm" ? "h-8 w-8 text-[13px]" : "h-10 w-10 text-[15px]";
  const title = size === "sm" ? "text-base" : "text-lg";

  return (
    <Link to="/" data-testid="brand-logo" className="flex items-center gap-2.5 focus-ring rounded-md">
      <div className={`grid place-items-center rounded-md ${dim} ${box} ${boxText} border ${border} font-display font-bold tracking-tighter`}>
        NS
      </div>
      <div className="leading-tight">
        <div className={`font-display font-bold ${title} ${primary}`}>
          Naukri<span className={accent}>·</span>Suchna
        </div>
        <div className={`text-[10px] tracking-[0.14em] uppercase ${inverse ? "text-white/60" : "text-slate-500"}`}>
          Govt. Job Portal
        </div>
      </div>
    </Link>
  );
}
